import React from "react";
//i18n
import { withNamespaces } from "react-i18next";
import { Container } from "reactstrap";
// Redux
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
//Import Breadcrumb
import Breadcrumb_2Items from "../../../../components/Common/Breadcrumb_2Items";
import EquipmentInventory from "../../../../components/Inventory/EquipmentInventory";

const ViewInventory = (props) => {
  

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb_2Items
            title={props.t("Inventory")}
            breadcrumbItem1={props.t("Equipments")}
            breadcrumbItem2={props.t("View Inventory")}
          />
          <EquipmentInventory/>
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => {};
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(ViewInventory))
);
